import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import AddPanelForm from "../../../UI/Panels/Add";

const AddPanel = () => {
  return (
    <div>
      <PanelHead title="Add panel" />
      <PanelBody content={<AddPanelForm />} />
    </div>
  );
};

export default React.memo(AddPanel);
